import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant.js';
import { useDispatch, useSelector } from 'react-redux';
import FJCommonRightHeaderView from '../../../FJMainPreview/FJDisplayHeader/FJCommonRightHeaderView.jsx';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover.js';

const FJPhotoRemoveBgRightHeaderButtons = () => {
    const dispatch = useDispatch();

    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const isPhotoRemoveBg = useSelector(state => state.brushEditCommon.isPhotoRemoveBg);
    const curMenuIndex = useSelector(state => state.photoBgRemover.curMenuIndex);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const thumbnailList = useSelector(state => state.photoBgRemover.thumbnailList);
    const customEditBgImageData = useSelector(state => state.photoBgRemover.customEditBgImageData);

    const selectedDownloadList = useSelector(state => state.common.selectedDownloadList);
    const isApplyButton = useSelector(state => state.common.isApplyButton);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);

    const isShow = isPhotoRemoveBg && brushEditStatus === FJConstant.DEFAULT && headerTabIndex === 0;

    const downloadList = useMemo(() => {
        if (!isShow) return [];

        if (curMenuIndex === 0) {
            return thumbnailList
                .filter(item => item.status === FJConstant.SUCCESS)
                .map(item => {
                    return { ...item, url: item.thumbnailUrl };
                });
        } else {
            return [customEditBgImageData];
        }
    }, [thumbnailList, curMenuIndex, customEditBgImageData, isShow]);

    const canDownloadMultiple = curMenuIndex === 0 && downloadList.length > 1;

    const _selectAll = () => {
        dispatch(FJActionCommon.setSelectedDownloadItemsAction([...downloadList]));
    };

    const _deselectAll = () => {
        dispatch(FJActionCommon.setSelectedDownloadItemsAction([]));
    };

    const _selectItem = (id, selected) => {
        if (selected) {
            const item = downloadList.find(item => item.id === id);
            if (selectedDownloadList.indexOf(item) === -1) {
                const newList = [...selectedDownloadList];
                newList.push(item);
                dispatch(FJActionCommon.setSelectedDownloadItemsAction(newList));
            }
        } else {
            const index = selectedDownloadList.findIndex(item => item.id === id);
            if (index !== -1) {
                const newList = selectedDownloadList.filter(item => item.id !== id);
                dispatch(FJActionCommon.setSelectedDownloadItemsAction(newList));
            }
        }
    };

    const _download = () => {
        dispatch(FJActionCommon.downloadSelectedItemsAction());
    };

    const _onApply = () => {
        dispatch(FJActionPhotoBgRemover.applyToEditPageAction());
    };

    const _onAddToMediaLibrary = () => {
        dispatch(FJActionPhotoBgRemover.addMultipleMediaToMediaLibraryAction({ from: 'generate' }));
    };

    if (!isShow) return null;

    return (
        <FJCommonRightHeaderView
            useApplyButton={isApplyButton}
            list={downloadList}
            selectedDownloadList={selectedDownloadList}
            isDownloading={batchDownloadLoading}
            selectAll={_selectAll}
            deselectAll={_deselectAll}
            selectItem={_selectItem}
            onDownload={_download}
            onApply={_onApply}
            onAddToMediaLibrary={_onAddToMediaLibrary}
            disableDownloadMultipleSource={!canDownloadMultiple}
        />
    );
};

export default FJPhotoRemoveBgRightHeaderButtons;
